import doc                         from 'decorators/doc';
import model                       from 'decorators/model';
import InterventionPrivateApiModel from 'modelx/models/abstracts/InterventionPrivateApiModel';

// @model.cacheDuration()
@model.staticLabel('Statut')
@model.urnResource('task_operation_article_status')
@doc.path('/task_operation_article_statuses/{?id}')
export default class TaskOperationArticleStatusModel extends InterventionPrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'reference': InterventionTaskOperationArticleStatusReference;
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.string declare label: string;
	@doc.string declare reference: InterventionTaskOperationArticleStatusReference;

	get color() {
		switch (this.reference) {
			case 'available':
				return 'green';
			case 'cancelled':
				return 'red';
			case 'waiting':
				return 'blue';
		}
	}
}